import React from 'react';
import Dropdown from '../../dropdowns/dropdowns';
import Links from '../../links/links';
import {PREFIX_REPOSITORY,POSTFIX_REPOSITORY, BASE_URL_TRASPASO} from '../../../constants/URLs';

const Procedimiento = () => {

  const getData = () => {

    const procedimientoTraspaso = process.env.GATSBY_PROCEDIMIENTO_TRASPASO;
    const procedimientoEmail = process.env.GATSBY_PROCEDIMIENTO_EMAIL;

    var data = [];
    var index = 0;
    if (procedimientoTraspaso === 'true') {
      data[index] = {
        titulo: '100% Digital',
        descripcion:
          <React.Fragment>
            <p className='mb-3'>Completa en solo 4 pasos tu solicitud de traspaso desde tu PC, tablet o celular <Links to={`${BASE_URL_TRASPASO}/pasos0`}>aquí.</Links> </p>
            
          </React.Fragment>
      };
     
      index++;
    }
    if (procedimientoEmail === 'true') {
      data[index] = {
        titulo: 'Correo Electrónico',
        descripcion:
          <div>
            <p className='mb-3'>Escríbenos a  <Links to='mailto:mitraspasoaprima@prima.com.pe'>mitraspasoaprima@prima.com.pe</Links> y adjunta:</p>
            <ul className='bullets mb-3'>
              <li>Tu <Links to={PREFIX_REPOSITORY + '2022/pdf/' + 'Prima_Traspaso.pdf' + POSTFIX_REPOSITORY} >solicitud de traspaso</Links> firmada y escaneada</li>
              <li>Una copia de tu documento de identidad vigente</li>
            </ul>
            <p className='mb-3'>Recibirás un correo de confirmación y te llamaremos para validar los datos</p>

          </div>
      };
    }
    return data;
  }


  return (
    <Dropdown data={getData()}
    />
  );


};

export default Procedimiento